define( [ 'utility' ], function run( utility ) {
	'use strict';

	var mCountrySelectionFn = {

		init : function( elm ) {
			var onResize,
				selectedListItem,
				selectedSection,
				selectedTab;

			if ( !elm.classList.contains( 'js-m-country-selection' ) ) {
				elm.classList.add( 'js-m-country-selection' );

				elm.mCountrySelection = {};
				elm.mCountrySelection.settings = {
					direction : {
						Left : -1,
						ArrowLeft : -1,
						Right : 1,
						ArrowRight : 1,
						Home : 0,
						End : 0,
					},
				};

				// Sets the group headings
				elm.mCountrySelection.settings.groupHeadings = elm.querySelectorAll( '.m-country-selection__heading' );

				// Creates breakpoint element
				elm.mCountrySelection.settings.breakpointElement = document.createElement( 'div' );
				elm.mCountrySelection.settings.breakpointElement.classList.add( 'm-country-selection__breakpoint' );
				elm.append( elm.mCountrySelection.settings.breakpointElement );
				elm.mCountrySelection.settings.currentBreakpoint = utility.getBreakpoint( elm.mCountrySelection.settings.breakpointElement );
				elm.mCountrySelection.settings.isAnimating = false;

				// Sets up the tab links
				mCountrySelectionFn.setupTabs( elm );

				// Selects key elements and puts them into the settings object
				elm.mCountrySelection.settings.tabLinks = Array.from( elm.querySelectorAll( '.m-country-sections__tab-list a' ) );

				// Adds the click event listener to each of the links to run the close tabs and then open tabs functions
				elm.mCountrySelection.settings.tabLinks.forEach( function loop( tabLink ) {
					tabLink.addEventListener( 'click', function listener( e ) {
						e.preventDefault();
						if ( elm.mCountrySelection.settings.isAnimating || elm.mCountrySelection.settings.currentBreakpoint === utility.smallTag ) {
							// If at small breakpoint or already animating do nothing
						} else {
							elm.mCountrySelection.settings.isAnimating = true;
							mCountrySelectionFn.closeTabs( elm );
							mCountrySelectionFn.openTab( elm, tabLink, FRAMEWORK.timings.current.t500ms );
						}
					});
					tabLink.addEventListener( 'keydown', function listener( e ) {
						var pressed = e.key,
							direction = elm.mCountrySelection.settings.direction[ pressed ];

						// Catch Arrow, Home or End key presses before they are processed for the page
						if ( elm.mCountrySelection.settings.currentBreakpoint === utility.smallTag ) {
							// If at small breakpoint do nothing
						} else if ( Number.isInteger( direction ) ) {
							e.preventDefault();
							mCountrySelectionFn.switchTabOnArrowPress( elm, e );
						} else if ( pressed === ' ' || pressed === 'Spacebar' ) {
							e.preventDefault();
							tabLink.click();
						}
					});
				});

				// Checks to see if resize tabs should run if there is a change in breakpoint
				onResize = utility.debounce( function listener() {
					var newBreakpoint = utility.getBreakpoint( elm.mCountrySelection.settings.breakpointElement );
					if ( newBreakpoint !== elm.mCountrySelection.settings.currentBreakpoint ) {
						elm.mCountrySelection.settings.currentBreakpoint = newBreakpoint;
						mCountrySelectionFn.resizeTabs( elm );
					}
				}, 10 );
				window.addEventListener( 'resize', onResize );

				// Closes the tabs to set the closed attribute values
				mCountrySelectionFn.closeTabs( elm );

				// Adds the js-m-country-selection-current class to the current tab link
				selectedListItem = elm.querySelector( '.m-country-selection-list__item.is-selected' );

				// Adds the relevant classes to the currently opened tab based on the selected list item
				if ( typeof selectedListItem !== 'undefined' && selectedListItem !== null ) {
					selectedSection = selectedListItem.closest( '.m-country-sections__tab-panel' );
					selectedTab = elm.querySelector( 'a[href="#' + selectedSection.id + '"]' );
					selectedTab.classList.add( 'js-m-country-selection-current' );
					selectedTab.classList.add( 'is-open' );
				} else {
					elm.mCountrySelection.settings.tabLinks[ 0 ].classList.add( 'js-m-country-selection-current' );
					elm.mCountrySelection.settings.tabLinks[ 0 ].classList.add( 'is-open' );
				}

				// Run resize tabs to apply the changes
				mCountrySelectionFn.resizeTabs( elm );
			}

			return elm.mCountrySelection;
		},

		setupTabs : function( elm ) {
			var mainHeading;

			// Creates new tab list element
			elm.mCountrySelection.settings.tabList = document.createElement( 'ul' );
			elm.mCountrySelection.settings.tabList.classList.add( 'a-list-plain' );
			elm.mCountrySelection.settings.tabList.classList.add( 'm-country-sections__tab-list' );
			elm.mCountrySelection.settings.tabList.setAttribute( 'role', 'tablist' );

			// Creates and appends links for each heading
			elm.mCountrySelection.settings.groupHeadings.forEach( function loop( heading ) {
				var tabId = utility.makeId( 'm-country-selection' ),
					tab,
					tabPanel = utility.htmlStringToElement( '<div class="m-country-sections__tab-panel" id="' + tabId +
						'" role="tabpanel" aria-hidden="false" aria-labelledby="' + tabId + '-tab"></div>' );

				tab = '<li role="presentation"><a href="#' + tabId + '" role="tab"  id="' + tabId + '-tab" aria-controls="' + tabId + '" aria-selected="true">' + heading.innerHTML + '</a></li>';
				elm.mCountrySelection.settings.tabList.insertAdjacentHTML( 'beforeend', tab );

				heading.setAttribute( 'aria-hidden', 'false' );
				heading.insertAdjacentElement( 'beforebegin', tabPanel );
				tabPanel.append( heading );
				tabPanel.append( tabPanel.nextElementSibling );
			});

			// Inserts the tab list
			mainHeading = elm.querySelector( '.m-country-selection__main-heading' );
			elm.insertBefore( elm.mCountrySelection.settings.tabList, mainHeading.nextElementSibling );

			elm.mCountrySelection.settings.groupSections = elm.querySelectorAll( '.m-country-sections__tab-panel' );
		},

		openTab : function( elm, tab, fadeSpeed ) {
			// Gets the section based on the selected tab link
			var section = elm.querySelector( '.m-country-sections__tab-panel' + tab.getAttribute( 'href' ) );

			// Sets the attributes
			tab.classList.add( 'is-open' );
			tab.setAttribute( 'aria-selected', 'true' );
			tab.removeAttribute( 'tabindex' );

			// Fades in the section
			utility.fade( section, fadeSpeed, {
				variant : 'in',
				callback : function() {
					var scrollParent = utility.scrollParent( section ),
						scrollParentPos = scrollParent.scrollTop,
						scrollWindowPos = window.pageYOffset;
					section.setAttribute( 'aria-hidden', 'false' );
					section.setAttribute( 'tabindex', '-1' );
					section.focus();
					scrollParent.scrollTop = scrollParentPos; // Reset to original position
					window.scroll( window.pageXOffset, scrollWindowPos ); // Reset to original position
					section.firstElementChild.setAttribute( 'aria-hidden', 'false' );
					elm.mCountrySelection.settings.isAnimating = false;
				},
			});
		},

		closeTabs : function( elm ) {
			// Loops through the tab links and sets all of the attributes to the unselected state
			elm.mCountrySelection.settings.tabLinks.forEach( function loop( link ) {
				link.setAttribute( 'aria-selected', 'false' );
				link.setAttribute( 'tabindex', -1 );
				link.classList.remove( 'is-open' );
			});

			// Loops through each of the headings and sets the attributes to the unselected state and hides the sections
			elm.mCountrySelection.settings.groupHeadings.forEach( function loop( heading ) {
				var section = heading.parentElement;
				heading.setAttribute( 'aria-hidden', 'true' );
				section.setAttribute( 'aria-hidden', 'true' );
				section.style.display = 'none';
			});
		},

		resizeTabs : function( elm ) {
			var largestSectionSize = 0,
				selectedTab;

			// Checks the breakpoint and if smallTag set the styling and attributes
			if ( elm.mCountrySelection.settings.currentBreakpoint === utility.smallTag ) {
				elm.mCountrySelection.settings.tabList.removeAttribute( 'role' );

				elm.mCountrySelection.settings.groupHeadings.forEach( function loop( heading ) {
					heading.setAttribute( 'aria-hidden', 'false' );
				});
				elm.mCountrySelection.settings.groupSections.forEach( function loop( section ) {
					section.style.minHeight = '0';
					section.style.display = 'block';
					section.setAttribute( 'aria-hidden', 'false' );
					section.removeAttribute( 'role' );
				});
				elm.mCountrySelection.settings.tabLinks.forEach( function loop( tabLink ) {
					tabLink.removeAttribute( 'role' );
				});
			} else {
				elm.mCountrySelection.settings.tabList.setAttribute( 'role', 'tablist' );

				// Finds the largest section
				elm.mCountrySelection.settings.groupSections.forEach( function loop( section ) {
					var currentSectionSize;
					section.style.display = 'block';
					currentSectionSize = section.offsetHeight;
					if ( currentSectionSize > largestSectionSize ) {
						largestSectionSize = currentSectionSize;
					}
				});
				// Sets the min height for all the sections to the largest section size in px and then hides them
				elm.mCountrySelection.settings.groupSections.forEach( function loop( section ) {
					section.style.minHeight = largestSectionSize + 'px';
					section.style.display = 'none';
					section.setAttribute( 'role', 'tabpanel' );
				});

				elm.mCountrySelection.settings.tabLinks.forEach( function loop( tabLink ) {
					tabLink.setAttribute( 'role', 'tab' );
				});

				// Finds the current selected tab and then run the open tab function on it
				selectedTab = elm.querySelector( '.m-country-sections__tab-list .is-open' );
				mCountrySelectionFn.openTab( elm, selectedTab, 0 );
			}
		},

		switchTabOnArrowPress : function( elm, event ) {
			var pressed = event.key,
				target = event.target,
				targetIndex = elm.mCountrySelection.settings.tabLinks.indexOf( target ),
				direction = elm.mCountrySelection.settings.direction[ pressed ];

			if ( Number.isInteger( direction ) ) {
				if ( targetIndex >= 0 ) {
					if ( pressed === 'Home' ) {
						elm.mCountrySelection.settings.tabLinks[ 0 ].focus(); // Move to first tab
					} else if ( pressed === 'End' ) {
						elm.mCountrySelection.settings.tabLinks[ elm.mCountrySelection.settings.tabLinks.length - 1 ].focus(); // Move to last tab
					} else if ( elm.mCountrySelection.settings.tabLinks[ targetIndex + direction ] ) {
						elm.mCountrySelection.settings.tabLinks[ targetIndex + direction ].focus(); // Move by one tab left or right
					} else if ( direction === -1 ) {
						elm.mCountrySelection.settings.tabLinks[ elm.mCountrySelection.settings.tabLinks.length - 1 ].focus(); // Loop around to last tab
					} else if ( direction === 1 ) {
						elm.mCountrySelection.settings.tabLinks[ 0 ].focus(); // Loop around to first tab
					} else {
						// Do nothing
					}
				}
			}
		},
	};

	return {
		initInstance : function( elm ) {
			return mCountrySelectionFn.init( elm );
		},
	};
});
